module.exports = __webpack_public_path__ + "static/media/alif_hastono.b1394e31.jpg";